import announcementApi from '@/services/announcement/announcementApi'

const state = {
    feed: [],
    meta: { current_page: 1, last_page: 1, total: 0 },
    current: null,
}

const getters = {}

const mutations = {
    SET_FEED(state, { data, meta }) {
        state.feed = data
        if (meta) state.meta = meta
    },
    SET_CURRENT(state, announcement) {
        state.current = announcement
    },
}

const actions = {
    async fetchFeed({ commit }, { q, page } = {}) {
        const res = await announcementApi.fetchFeed(q, page)
        commit('SET_FEED', { data: res.data, meta: res.meta })   // commit ก่อน return
        return res
    },

    fetchActive() {
        return announcementApi.fetchActive()   // ใช้ใน popup หน้าแรก, ไม่ต้องเก็บใน state
    },

    async fetchDetail({ commit }, id) {
        const announcement = await announcementApi.fetchDetail(id)
        commit('SET_CURRENT', announcement)
        return announcement
    },

    // บันทึกว่าอ่านแล้ว (v2) → คืน read_count ล่าสุดให้ component อัปเดตตัวเลข
    markRead(_, id) {
        return announcementApi.markRead(id)
    },
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
}
